/*@ngInject*/
const FormSnippetBlobRepository = function (baseCachedRepository) {

    angular.extend(this, baseCachedRepository);

    this.getCacheName = function () {
        return 'snippetsBlobRepository';
    };

    this.getCacheCapacity = function () {
        return 10;
    };

    this.getSnippetBlob = function (snippetId) {
        let url = '/rest/Snippet/' + snippetId + '/blob',
            cacheKey = 'snippetBlob:' + snippetId;

        return this.get(cacheKey, url);
    };
};

angular.module('umFormViewer')
    .service('formSnippetBlobRepository', FormSnippetBlobRepository);
